var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgQr = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 91,
  height: 91,
  viewBox: "0 0 91 91",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 90.9502,
  height: 90.6946,
  rx: 8.01323,
  fill: "white"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28.5886 10.6649V8.91484C28.5886 8.41694 28.9922 8.01332 29.4901 8.01332H30.3386C30.8365 8.01332 31.2402 8.41694 31.2402 8.91484V10.6649H28.5886Z",
  fill: "black"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3855 10.6648H34.6355C34.1376 10.6648 33.734 10.2612 33.734 9.76327V8.91478C33.734 8.41688 34.1376 8.01326 34.6355 8.01326H36.3855V10.6648Z",
  fill: "black"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.9565 8.01398H36.3049V10.6655H38.9565V8.01398Z",
  fill: "black"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M38.8774 10.6649V8.01332H40.6275C41.1254 8.01332 41.529 8.41694 41.529 8.91484V10.6649H38.8774Z",
  fill: "black"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M51.818 10.6648H50.068C49.5701 10.6648 49.1665 10.2612 49.1665 9.76327V8.91478C49.1665 8.41688 49.5701 8.01326 50.068 8.01326H51.818V10.6648Z",
  fill: "black"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M51.7375 10.6649V8.01332H53.4876C53.9855 8.01332 54.3891 8.41694 54.3891 8.91484V10.6649H51.7375Z",
  fill: "black"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M56.8813 10.6649V8.91484C56.8813 8.41694 57.285 8.01332 57.7829 8.01332H58.6314C59.1293 8.01332 59.5329 8.41694 59.5329 8.91484V10.6649H56.8813Z",
  fill: "black"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2402 10.5864H28.5886V13.2379H31.2402V10.5864Z",
  fill: "black"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M31.1621 13.2383V10.5867H32.9121C33.41 10.5867 33.8136 10.9904 33.8136 11.4883V13.2383H31.1621Z",
  fill: "black"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5289 10.5865H38.8773V13.238H41.5289V10.5865Z",
  fill: "black"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M59.5329 10.5864H56.8813V13.2379H59.5329V10.5864Z",
  fill: "black"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M59.4529 13.2383V10.5867H61.2029C61.7008 10.5867 62.1044 10.9904 62.1044 11.4883V13.2383H59.4529Z",
  fill: "black"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2402 13.1589H28.5886V15.8104H31.2402V13.1589Z",
  fill: "black"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M38.9559 15.8097H37.2059C36.708 15.8097 36.3044 15.4061 36.3044 14.9082V14.0597C36.3044 13.5618 36.708 13.1582 37.2059 13.1582H38.9559V15.8097Z",
  fill: "black"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5289 13.1588H38.8773V15.8103H41.5289V13.1588Z",
  fill: "black"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M41.449 15.8097V13.1582H43.199C43.6969 13.1582 44.1005 13.5618 44.1005 14.0597V15.8097H41.449Z",
  fill: "black"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M49.165 13.9172V15.0547C49.165 15.4736 49.5044 15.8104 49.9234 15.8104H51.0609C51.4825 15.8104 51.8192 15.471 51.8192 15.052V13.9172C51.8166 13.4956 51.4772 13.1588 51.0582 13.1588H49.9234C49.5044 13.1588 49.165 13.4982 49.165 13.9172Z",
  fill: "black"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M59.5329 13.1589H56.8813V15.8104H59.5329V13.1589Z",
  fill: "black"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M59.4529 13.1589H62.1044V14.9089C62.1044 15.4068 61.7008 15.8104 61.2029 15.8104H59.4529V13.1589Z",
  fill: "black"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2402 15.7303H28.5886V18.3818H31.2402V15.7303Z",
  fill: "black"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M33.7336 18.3821V16.6321C33.7336 16.1342 34.1373 15.7306 34.6352 15.7306H35.4837C35.9816 15.7306 36.3852 16.1342 36.3852 16.6321V18.3821H33.7336Z",
  fill: "black"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M41.529 15.7303H38.8774V18.3818H41.529V15.7303Z",
  fill: "black"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M44.1005 15.7303H41.449V18.3818H44.1005V15.7303Z",
  fill: "black"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M44.0222 18.3821V15.7306H45.7722C46.2701 15.7306 46.6738 16.1342 46.6738 16.6321V18.3821H44.0222Z",
  fill: "black"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M56.1521 18.3281V18.3812H56.9608V17.5724H56.9078C56.9078 17.9914 56.5684 18.3281 56.1521 18.3281Z",
  fill: "black"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M59.5329 15.7303H56.8813V18.3818H59.5329V15.7303Z",
  fill: "black"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2416 18.3017V20.0517C31.2416 20.5496 30.838 20.9532 30.3401 20.9532H29.4916C28.9937 20.9532 28.59 20.5496 28.59 20.0517V18.3017H31.2416Z",
  fill: "black"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3855 18.3017V20.0517C36.3855 20.5496 35.9819 20.9532 35.484 20.9532H34.6355C34.1376 20.9532 33.734 20.5496 33.734 20.0517V18.3017H36.3855Z",
  fill: "black"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M38.1482 20.9015V20.9545H38.9569V20.1458H38.9039C38.9039 20.5648 38.5645 20.9015 38.1482 20.9015Z",
  fill: "black"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M41.529 18.3017H38.8774V20.9532H41.529V18.3017Z",
  fill: "black"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M41.449 18.3017H44.1005V20.0517C44.1005 20.5496 43.6969 20.9532 43.199 20.9532H41.449V18.3017Z",
  fill: "black"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M46.5928 20.9546V19.2046C46.5928 18.7067 46.9964 18.3031 47.4943 18.3031H48.3428C48.8407 18.3031 49.2443 18.7067 49.2443 19.2046V20.9546H46.5928Z",
  fill: "black"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M54.3884 20.9546H51.7369V19.2046C51.7369 18.7067 52.1405 18.3031 52.6384 18.3031H54.3884V20.9546Z",
  fill: "black"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M56.9606 18.3017H54.3091V20.9532H56.9606V18.3017Z",
  fill: "black"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M59.5329 18.3017H56.8813V20.9532H59.5329V18.3017Z",
  fill: "black"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M38.9558 23.525H37.2058C36.7079 23.525 36.3043 23.1213 36.3043 22.6234V21.7749C36.3043 21.277 36.7079 20.8734 37.2058 20.8734H38.9558V23.525Z",
  fill: "black"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M41.529 20.8742H38.8774V23.5257H41.529V20.8742Z",
  fill: "black"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M49.2446 20.8742V22.6242C49.2446 23.1221 48.841 23.5257 48.3431 23.5257H47.4946C46.9967 23.5257 46.5931 23.1221 46.5931 22.6242V20.8742H49.2446Z",
  fill: "black"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M54.3884 20.8742V22.6242C54.3884 23.1221 53.9848 23.5257 53.4869 23.5257H52.6384C52.1405 23.5257 51.7369 23.1221 51.7369 22.6242V20.8742H54.3884Z",
  fill: "black"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M59.5323 20.8742V22.6242C59.5323 23.1221 59.1287 23.5257 58.6308 23.5257H57.7823C57.2844 23.5257 56.8808 23.1221 56.8808 22.6242V20.8742H59.5323Z",
  fill: "black"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5886 26.0984V24.3484C28.5886 23.8505 28.9922 23.4468 29.4901 23.4468H30.3386C30.8365 23.4468 31.2402 23.8505 31.2402 24.3484V26.0984H28.5886Z",
  fill: "black"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M33.7339 24.205V25.3425C33.7339 25.7614 34.0733 26.0982 34.4922 26.0982H35.6297C36.0513 26.0982 36.3881 25.7588 36.3881 25.3399V24.205C36.3854 23.7834 36.046 23.4467 35.6271 23.4467H34.4922C34.0733 23.4467 33.7339 23.7861 33.7339 24.205Z",
  fill: "black"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5283 23.4466V25.1966C41.5283 25.6945 41.1247 26.0981 40.6268 26.0981H39.7783C39.2804 26.0981 38.8768 25.6945 38.8768 25.1966V23.4466H41.5283Z",
  fill: "black"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M44.0222 24.2049V25.3424C44.0222 25.7614 44.3616 26.0981 44.7806 26.0981H45.9181C46.3397 26.0981 46.6764 25.7587 46.6764 25.3398V24.2049C46.6738 23.7833 46.3344 23.4466 45.9154 23.4466H44.7806C44.3616 23.4466 44.0222 23.786 44.0222 24.2049Z",
  fill: "black"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M49.1652 24.205V25.3425C49.1652 25.7614 49.5046 26.0982 49.9235 26.0982H51.061C51.4826 26.0982 51.8194 25.7588 51.8194 25.3399V24.205C51.8167 23.7834 51.4773 23.4467 51.0584 23.4467H49.9235C49.5046 23.4467 49.1652 23.7861 49.1652 24.205Z",
  fill: "black"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "M53.5807 26.0444V26.0974H54.3894V25.2887H54.3364C54.3364 25.7076 53.997 26.0444 53.5807 26.0444Z",
  fill: "black"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  d: "M54.3091 26.0984V24.3484C54.3091 23.8505 54.7127 23.4468 55.2106 23.4468H56.0591C56.557 23.4468 56.9606 23.8505 56.9606 24.3484V26.0984H54.3091Z",
  fill: "black"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  d: "M59.4529 24.2049V25.3424C59.4529 25.7614 59.7923 26.0981 60.2112 26.0981H61.3487C61.7703 26.0981 62.1071 25.7587 62.1071 25.3398V24.2049C62.1044 23.7833 61.765 23.4466 61.3461 23.4466H60.2112C59.7923 23.4466 59.4529 23.786 59.4529 24.2049Z",
  fill: "black"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2416 26.018V28.6695H29.4916C28.9937 28.6695 28.59 28.2659 28.59 27.768V26.018H31.2416Z",
  fill: "black"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  d: "M31.1621 28.6689V26.0173H32.9121C33.41 26.0173 33.8136 26.421 33.8136 26.9189V28.6689H31.1621Z",
  fill: "black"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3049 26.7762V27.9137C36.3049 28.3327 36.6443 28.6694 37.0633 28.6694H38.2008C38.6224 28.6694 38.9591 28.33 38.9591 27.9111V26.7762C38.9565 26.3546 38.6171 26.0179 38.1981 26.0179H37.0633C36.6443 26.0179 36.3049 26.3573 36.3049 26.7762Z",
  fill: "black"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  d: "M51.0083 28.6168V28.6699H51.817V27.8611H51.764C51.764 28.2801 51.4246 28.6168 51.0083 28.6168Z",
  fill: "black"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  d: "M54.3884 28.6689H51.7369V26.9189C51.7369 26.421 52.1405 26.0173 52.6384 26.0173H54.3884V28.6689Z",
  fill: "black"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  d: "M56.9606 26.018H54.3091V28.6695H56.9606V26.018Z",
  fill: "black"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2366 31.2413H11.4866C10.9887 31.2413 10.585 30.8377 10.585 30.3398V29.4913C10.585 28.9934 10.9887 28.5898 11.4866 28.5898H13.2366V31.2413Z",
  fill: "black"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1582 31.2413V28.5897H14.9082C15.4061 28.5897 15.8097 28.9934 15.8097 29.4913V31.2413H13.1582Z",
  fill: "black"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5728 31.1892V31.2423H18.3815V30.4335H18.3284C18.3284 30.8525 17.989 31.1892 17.5728 31.1892Z",
  fill: "black"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  d: "M18.302 31.2413V29.4913C18.302 28.9934 18.7056 28.5898 19.2035 28.5898H20.052C20.5499 28.5898 20.9535 28.9934 20.9535 29.4913V31.2413H18.302Z",
  fill: "black"
})), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0967 31.2413H24.3467C23.8488 31.2413 23.4451 30.8377 23.4451 30.3398V29.4913C23.4451 28.9934 23.8488 28.5898 24.3467 28.5898H26.0967V31.2413Z",
  fill: "black"
})), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0173 31.2413V28.5898H27.7674C28.2652 28.5898 28.6689 28.9934 28.6689 29.4913V31.2413H26.0173Z",
  fill: "black"
})), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
  d: "M38.1482 31.1892V31.2423H38.9569V30.4335H38.9039C38.9039 30.8525 38.5645 31.1892 38.1482 31.1892Z",
  fill: "black"
})), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5283 31.2413H38.8768V29.4913C38.8768 28.9934 39.2804 28.5898 39.7783 28.5898H41.5283V31.2413Z",
  fill: "black"
})), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
  d: "M44.1005 28.5904H41.449V31.2419H44.1005V28.5904Z",
  fill: "black"
})), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
  d: "M44.0222 31.2413V28.5897H45.7722C46.2701 28.5897 46.6738 28.9934 46.6738 29.4913V31.2413H44.0222Z",
  fill: "black"
})), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
  d: "M48.4358 31.1892V31.2423H49.2445V30.4335H49.1915C49.1915 30.8525 48.8521 31.1892 48.4358 31.1892Z",
  fill: "black"
})), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
  d: "M51.818 31.2413H49.1665V29.4913C49.1665 28.9934 49.5701 28.5898 50.068 28.5898H51.818V31.2413Z",
  fill: "black"
})), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
  d: "M54.3891 28.5904H51.7375V31.2419H54.3891V28.5904Z",
  fill: "black"
})), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
  d: "M56.9606 28.5904H54.3091V31.2419H56.9606V28.5904Z",
  fill: "black"
})), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
  d: "M63.8684 31.1892V31.2423H64.6771V30.4335H64.6241C64.6241 30.8525 64.2847 31.1892 63.8684 31.1892Z",
  fill: "black"
})), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
  d: "M64.5978 31.2413V29.4913C64.5978 28.9934 65.0014 28.5898 65.4993 28.5898H66.3478C66.8457 28.5898 67.2493 28.9934 67.2493 29.4913V31.2413H64.5978Z",
  fill: "black"
})), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
  d: "M72.3926 31.2413H70.6426C70.1447 31.2413 69.741 30.8376 69.741 30.3397V29.4913C69.741 28.9934 70.1447 28.5897 70.6426 28.5897H72.3926V31.2413Z",
  fill: "black"
})), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
  d: "M74.9645 28.5904H72.313V31.2419H74.9645V28.5904Z",
  fill: "black"
})), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
  d: "M77.537 28.5904H74.8855V31.2419H77.537V28.5904Z",
  fill: "black"
})), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1095 28.5904H77.458V31.2419H80.1095V28.5904Z",
  fill: "black"
})), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
  d: "M80.0293 31.2413V28.5898H81.7793C82.2772 28.5898 82.6808 28.9934 82.6808 29.4913V31.2413H80.0293Z",
  fill: "black"
})), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8097 31.1619H13.1582V33.8135H15.8097V31.1619Z",
  fill: "black"
})), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3801 31.1619H15.7285V33.8135H18.3801V31.1619Z",
  fill: "black"
})), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9535 31.1619H18.302V33.8135H20.9535V31.1619Z",
  fill: "black"
})), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
  d: "M28.6681 31.1619V32.9119C28.6681 33.4098 28.2645 33.8135 27.7666 33.8135H26.9181C26.4202 33.8135 26.0166 33.4098 26.0166 32.9119V31.1619H28.6681Z",
  fill: "black"
})), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
  d: "M38.9567 33.8136H37.2066C36.7088 33.8136 36.3051 33.41 36.3051 32.9121V32.0636C36.3051 31.5657 36.7088 31.1621 37.2066 31.1621H38.9567V33.8136Z",
  fill: "black"
})), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
  d: "M38.8774 31.1619H41.529V32.9119C41.529 33.4098 41.1254 33.8135 40.6275 33.8135H38.8774V31.1619Z",
  fill: "black"
})), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
  d: "M49.2446 33.8137H47.4946C46.9967 33.8137 46.5931 33.4101 46.5931 32.9122V32.0637C46.5931 31.5658 46.9967 31.1622 47.4946 31.1622H49.2446V33.8137Z",
  fill: "black"
})), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
  d: "M49.165 31.1619H51.8166V32.9119C51.8166 33.4098 51.413 33.8135 50.9151 33.8135H49.165V31.1619Z",
  fill: "black"
})), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
  d: "M56.9609 31.1619V32.9119C56.9609 33.4098 56.5573 33.8135 56.0594 33.8135H55.2109C54.713 33.8135 54.3094 33.4098 54.3094 32.9119V31.1619H56.9609Z",
  fill: "black"
})), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1036 33.8136H59.4521V32.0636C59.4521 31.5657 59.8557 31.1621 60.3536 31.1621H62.1036V33.8136Z",
  fill: "black"
})), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
  d: "M64.6769 31.1619H62.0254V33.8135H64.6769V31.1619Z",
  fill: "black"
})), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
  d: "M64.5977 31.1619H67.2492V32.9119C67.2492 33.4098 66.8456 33.8135 66.3477 33.8135H64.5977V31.1619Z",
  fill: "black"
})), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
  d: "M74.964 31.1619V32.9119C74.964 33.4098 74.5604 33.8135 74.0625 33.8135H73.214C72.7161 33.8135 72.3124 33.4098 72.3124 32.9119V31.1619H74.964Z",
  fill: "black"
})), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
  d: "M82.6808 31.1619H80.0293V33.8135H82.6808V31.1619Z",
  fill: "black"
})), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2366 36.3862H10.585V34.6362C10.585 34.1383 10.9887 33.7346 11.4866 33.7346H13.2366V36.3862Z",
  fill: "black"
})), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8097 33.7353H13.1582V36.3868H15.8097V33.7353Z",
  fill: "black"
})), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3801 33.7353H15.7285V36.3868H18.3801V33.7353Z",
  fill: "black"
})), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9535 33.7353H18.302V36.3868H20.9535V33.7353Z",
  fill: "black"
})), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4458 34.4936V35.6311C23.4458 36.0501 23.7852 36.3868 24.2041 36.3868H25.3417C25.7632 36.3868 26.1 36.0474 26.1 35.6285V34.4936C26.0973 34.072 25.7579 33.7353 25.339 33.7353H24.2041C23.7852 33.7353 23.4458 34.0747 23.4458 34.4936Z",
  fill: "black"
})), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
  d: "M30.4329 36.3322V36.3852H31.2416V35.5765H31.1886C31.1886 35.9954 30.8492 36.3322 30.4329 36.3322Z",
  fill: "black"
})), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
  d: "M31.1621 36.3861V34.6361C31.1621 34.1382 31.5657 33.7346 32.0636 33.7346H32.9121C33.41 33.7346 33.8136 34.1382 33.8136 34.6361V36.3861H31.1621Z",
  fill: "black"
})), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1044 33.7353H59.4529V36.3868H62.1044V33.7353Z",
  fill: "black"
})), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
  d: "M67.1692 34.4936V35.6311C67.1692 36.0501 67.5086 36.3868 67.9275 36.3868H69.065C69.4866 36.3868 69.8234 36.0474 69.8234 35.6285V34.4936C69.8207 34.072 69.4813 33.7353 69.0624 33.7353H67.9275C67.5086 33.7353 67.1692 34.0747 67.1692 34.4936Z",
  fill: "black"
})), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1088 36.3861H77.4572V34.6361C77.4572 34.1382 77.8609 33.7346 78.3587 33.7346H80.1088V36.3861Z",
  fill: "black"
})), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
  d: "M80.0293 33.7353H82.6808V35.4853C82.6808 35.9832 82.2772 36.3868 81.7793 36.3868H80.0293V33.7353Z",
  fill: "black"
})), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2366 36.3067V38.9582H11.4866C10.9887 38.9582 10.585 38.5546 10.585 38.0567V36.3067H13.2366Z",
  fill: "black"
})), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8097 36.3067H13.1582V38.9582H15.8097V36.3067Z",
  fill: "black"
})), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9535 36.3067H18.302V38.9582H20.9535V36.3067Z",
  fill: "black"
})), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2416 38.9576H29.4916C28.9937 38.9576 28.59 38.554 28.59 38.0561V37.2076C28.59 36.7097 28.9937 36.3061 29.4916 36.3061H31.2416V38.9576Z",
  fill: "black"
})), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8136 36.3067H31.1621V38.9582H33.8136V36.3067Z",
  fill: "black"
})), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1038 36.3067V38.9582H60.3537C59.8558 38.9582 59.4522 38.5546 59.4522 38.0567V36.3067H62.1038Z",
  fill: "black"
})), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
  d: "M64.6769 36.3068H62.0254V38.9584H64.6769V36.3068Z",
  fill: "black"
})), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
  d: "M64.5977 38.9576V36.306H66.3477C66.8456 36.306 67.2492 36.7097 67.2492 37.2076V38.9576H64.5977Z",
  fill: "black"
})), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
  d: "M69.7417 37.065V38.2026C69.7417 38.6215 70.0811 38.9582 70.5 38.9582H71.6376C72.0591 38.9582 72.3959 38.6188 72.3959 38.1999V37.065C72.3932 36.6434 72.0538 36.3067 71.6349 36.3067H70.5C70.0811 36.3067 69.7417 36.6461 69.7417 37.065Z",
  fill: "black"
})), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1088 36.3067V38.0567C80.1088 38.5546 79.7051 38.9582 79.2072 38.9582H78.3587C77.8609 38.9582 77.4572 38.5546 77.4572 38.0567V36.3067H80.1088Z",
  fill: "black"
})), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
  d: "M8.01318 39.6355V40.773C8.01318 41.1919 8.35258 41.5287 8.77152 41.5287H9.90903C10.3306 41.5287 10.6674 41.1893 10.6674 40.7703V39.6355C10.6647 39.2139 10.3253 38.8771 9.90638 38.8771H8.77152C8.35258 38.8771 8.01318 39.2165 8.01318 39.6355Z",
  fill: "black"
})), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
  d: "M15.809 38.8771V41.5287H14.0589C13.561 41.5287 13.1574 41.1251 13.1574 40.6272V38.8771H15.809Z",
  fill: "black"
})), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3801 38.8771H15.7285V41.5287H18.3801V38.8771Z",
  fill: "black"
})), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
  d: "M18.302 38.8771H20.9535V40.6272C20.9535 41.1251 20.5499 41.5287 20.052 41.5287H18.302V38.8771Z",
  fill: "black"
})), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0967 41.5301H24.3467C23.8488 41.5301 23.4451 41.1265 23.4451 40.6286V39.7801C23.4451 39.2822 23.8488 38.8786 24.3467 38.8786H26.0967V41.5301Z",
  fill: "black"
})), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0173 41.53V38.8785H27.7674C28.2652 38.8785 28.6689 39.2821 28.6689 39.78V41.53H26.0173Z",
  fill: "black"
})), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
  d: "M30.4329 41.4771V41.5301H31.2416V40.7214H31.1886C31.1886 41.1403 30.8492 41.4771 30.4329 41.4771Z",
  fill: "black"
})), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8136 38.8771H31.1621V41.5287H33.8136V38.8771Z",
  fill: "black"
})), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
  d: "M67.2492 38.8771H64.5977V41.5287H67.2492V38.8771Z",
  fill: "black"
})), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
  d: "M67.1692 41.53V38.8785H68.9192C69.4171 38.8785 69.8207 39.2821 69.8207 39.78V41.53H67.1692Z",
  fill: "black"
})), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
  d: "M72.313 39.6355V40.773C72.313 41.1919 72.6524 41.5287 73.0713 41.5287H74.2088C74.6304 41.5287 74.9672 41.1893 74.9672 40.7703V39.6355C74.9645 39.2139 74.6251 38.8771 74.2062 38.8771H73.0713C72.6524 38.8771 72.313 39.2165 72.313 39.6355Z",
  fill: "black"
})), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5857 44.1014V42.3514C10.5857 41.8535 10.9893 41.4499 11.4872 41.4499H12.3357C12.8336 41.4499 13.2372 41.8535 13.2372 42.3514V44.1014H10.5857Z",
  fill: "black"
})), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
  d: "M28.6681 41.4506V44.1022H26.9181C26.4202 44.1022 26.0166 43.6985 26.0166 43.2006V41.4506H28.6681Z",
  fill: "black"
})), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2402 41.4506H28.5886V44.1022H31.2402V41.4506Z",
  fill: "black"
})), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8136 41.4506H31.1621V44.1022H33.8136V41.4506Z",
  fill: "black"
})), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1038 44.1014H59.4522V42.3514C59.4522 41.8535 59.8558 41.4499 60.3537 41.4499H62.1038V44.1014Z",
  fill: "black"
})), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
  d: "M64.6769 41.4506H62.0254V44.1022H64.6769V41.4506Z",
  fill: "black"
})), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
  d: "M67.2492 41.4506H64.5977V44.1022H67.2492V41.4506Z",
  fill: "black"
})), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
  d: "M69.8207 41.4506H67.1692V44.1022H69.8207V41.4506Z",
  fill: "black"
})), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
  d: "M79.3 44.0495V44.1025H80.1088V43.2938H80.0557C80.0557 43.7127 79.7163 44.0495 79.3 44.0495Z",
  fill: "black"
})), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
  d: "M80.0293 44.1014V42.3514C80.0293 41.8535 80.4329 41.4499 80.9308 41.4499H81.7793C82.2772 41.4499 82.6808 41.8535 82.6808 42.3514V44.1014H80.0293Z",
  fill: "black"
})), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
  d: "M9.85645 46.6209V46.6739H10.6652V45.8652H10.6121C10.6121 46.2841 10.2727 46.6209 9.85645 46.6209Z",
  fill: "black"
})), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2372 44.022H10.5857V46.6736H13.2372V44.022Z",
  fill: "black"
})), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8097 44.022H13.1582V46.6736H15.8097V44.022Z",
  fill: "black"
})), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7285 46.6738V44.0222H17.4785C17.9764 44.0222 18.3801 44.4259 18.3801 44.9238V46.6738H15.7285Z",
  fill: "black"
})), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4458 44.7804V45.9179C23.4458 46.3368 23.7852 46.6736 24.2041 46.6736H25.3417C25.7632 46.6736 26.1 46.3342 26.1 45.9152V44.7804C26.0973 44.3588 25.7579 44.022 25.339 44.022H24.2041C23.7852 44.022 23.4458 44.3614 23.4458 44.7804Z",
  fill: "black"
})), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
  d: "M33.813 44.022V45.7721C33.813 46.2699 33.4094 46.6736 32.9115 46.6736H32.063C31.5651 46.6736 31.1614 46.2699 31.1614 45.7721V44.022H33.813Z",
  fill: "black"
})), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
  d: "M58.7246 46.6209V46.6739H59.5333V45.8652H59.4803C59.4803 46.2841 59.1409 46.6209 58.7246 46.6209Z",
  fill: "black"
})), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1044 44.022H59.4529V46.6736H62.1044V44.022Z",
  fill: "black"
})), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
  d: "M64.6769 44.022H62.0254V46.6736H64.6769V44.022Z",
  fill: "black"
})), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
  d: "M69.8207 44.022H67.1692V46.6736H69.8207V44.022Z",
  fill: "black"
})), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
  d: "M77.5372 46.6738H75.7872C75.2893 46.6738 74.8857 46.2701 74.8857 45.7722V44.9238C74.8857 44.4259 75.2893 44.0222 75.7872 44.0222H77.5372V46.6738Z",
  fill: "black"
})), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1095 44.022H77.458V46.6736H80.1095V44.022Z",
  fill: "black"
})), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
  d: "M82.6808 44.022H80.0293V46.6736H82.6808V44.022Z",
  fill: "black"
})), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
  d: "M10.665 49.2463H8.91502C8.41712 49.2463 8.0135 48.8427 8.0135 48.3448V47.4963C8.0135 46.9984 8.41712 46.5948 8.91502 46.5948H10.665V49.2463Z",
  fill: "black"
})), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2372 46.5944H10.5857V49.246H13.2372V46.5944Z",
  fill: "black"
})), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8097 46.5944H13.1582V49.246H15.8097V46.5944Z",
  fill: "black"
})), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3801 46.5944H15.7285V49.246H18.3801V46.5944Z",
  fill: "black"
})), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
  d: "M25.2881 49.1923V49.2453H26.0968V48.4366H26.0438C26.0438 48.8555 25.7044 49.1923 25.2881 49.1923Z",
  fill: "black"
})), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
  d: "M28.6681 49.2463H26.0166V47.4963C26.0166 46.9984 26.4202 46.5948 26.9181 46.5948H28.6681V49.2463Z",
  fill: "black"
})), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5886 49.2463V46.5948H30.3386C30.8365 46.5948 31.2402 46.9984 31.2402 47.4963V49.2463H28.5886Z",
  fill: "black"
})), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
  d: "M59.5333 49.2463H57.7833C57.2854 49.2463 56.8818 48.8427 56.8818 48.3448V47.4963C56.8818 46.9984 57.2854 46.5948 57.7833 46.5948H59.5333V49.2463Z",
  fill: "black"
})), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1044 46.5944H59.4529V49.246H62.1044V46.5944Z",
  fill: "black"
})), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
  d: "M64.6769 46.5944H62.0254V49.246H64.6769V46.5944Z",
  fill: "black"
})), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
  d: "M69.8201 46.5944V48.3444C69.8201 48.8423 69.4164 49.246 68.9185 49.246H68.0701C67.5722 49.246 67.1685 48.8423 67.1685 48.3444V46.5944H69.8201Z",
  fill: "black"
})), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1095 46.5944H77.458V49.246H80.1095V46.5944Z",
  fill: "black"
})), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
  d: "M80.0293 46.5944H82.6808V48.3444C82.6808 48.8423 82.2772 49.246 81.7793 49.246H80.0293V46.5944Z",
  fill: "black"
})), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2372 49.1661H10.5857V51.8176H13.2372V49.1661Z",
  fill: "black"
})), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8097 49.1658H13.1582V51.8174H15.8097V49.1658Z",
  fill: "black"
})), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3801 49.166H15.7285V51.8175H18.3801V49.166Z",
  fill: "black"
})), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
  d: "M18.302 51.8168V49.1652H20.052C20.5499 49.1652 20.9535 49.5689 20.9535 50.0668V51.8168H18.302Z",
  fill: "black"
})), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0967 51.8168H24.3467C23.8488 51.8168 23.4451 51.4131 23.4451 50.9152V50.0668C23.4451 49.5689 23.8488 49.1652 24.3467 49.1652H26.0967V51.8168Z",
  fill: "black"
})), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
  d: "M28.6686 49.1661H26.0171V51.8176H28.6686V49.1661Z",
  fill: "black"
})), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2402 49.166H28.5886V51.8175H31.2402V49.166Z",
  fill: "black"
})), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1044 49.166H59.4529V51.8175H62.1044V49.166Z",
  fill: "black"
})), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
  d: "M64.6769 49.1661H62.0254V51.8176H64.6769V49.1661Z",
  fill: "black"
})), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
  d: "M64.5977 51.8168V49.1652H66.3477C66.8456 49.1652 67.2492 49.5689 67.2492 50.0668V51.8168H64.5977Z",
  fill: "black"
})), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
  d: "M72.313 49.9243V51.0618C72.313 51.4807 72.6524 51.8175 73.0713 51.8175H74.2088C74.6304 51.8175 74.9672 51.4781 74.9672 51.0592V49.9243C74.9645 49.5027 74.6251 49.166 74.2062 49.166H73.0713C72.6524 49.166 72.313 49.5054 72.313 49.9243Z",
  fill: "black"
})), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1094 49.1661H77.4579V51.8176H80.1094V49.1661Z",
  fill: "black"
})), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2365 51.7383V53.4884C13.2365 53.9863 12.8328 54.3899 12.3349 54.3899H11.4864C10.9885 54.3899 10.5849 53.9863 10.5849 53.4884V51.7383H13.2365Z",
  fill: "black"
})), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
  d: "M20.144 54.3372V54.3902H20.9528V53.5815H20.8997C20.8997 54.0004 20.5603 54.3372 20.144 54.3372Z",
  fill: "black"
})), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
  d: "M20.8733 54.3912V52.6412C20.8733 52.1433 21.2769 51.7396 21.7748 51.7396H22.6233C23.1212 51.7396 23.5248 52.1433 23.5248 52.6412V54.3912H20.8733Z",
  fill: "black"
})), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2416 51.7383V53.4884C31.2416 53.9863 30.838 54.3899 30.3401 54.3899H29.4916C28.9937 54.3899 28.59 53.9863 28.59 53.4884V51.7383H31.2416Z",
  fill: "black"
})), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1038 51.7383V53.4884C62.1038 53.9863 61.7001 54.3899 61.2022 54.3899H60.3537C59.8558 54.3899 59.4522 53.9863 59.4522 53.4884V51.7383H62.1038Z",
  fill: "black"
})), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
  d: "M67.2487 51.7383V54.3899H65.4986C65.0007 54.3899 64.5971 53.9863 64.5971 53.4884V51.7383H67.2487Z",
  fill: "black"
})), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
  d: "M67.1692 54.3912V51.7396H68.9192C69.4171 51.7396 69.8207 52.1433 69.8207 52.6412V54.3912H67.1692Z",
  fill: "black"
})), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
  d: "M76.7277 54.337V54.3901H77.5364V53.5814H77.4834C77.4834 54.0003 77.144 54.337 76.7277 54.337Z",
  fill: "black"
})), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1094 51.7383H77.4579V54.3898H80.1094V51.7383Z",
  fill: "black"
})), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
  d: "M80.0293 54.3912V51.7396H81.7793C82.2772 51.7396 82.6808 52.1433 82.6808 52.6412V54.3912H80.0293Z",
  fill: "black"
})), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
  d: "M8.01343 55.0688V56.2063C8.01343 56.6253 8.35282 56.962 8.77177 56.962H9.90928C10.3309 56.962 10.6676 56.6226 10.6676 56.2037V55.0688C10.665 54.6472 10.3256 54.3105 9.90663 54.3105H8.77177C8.35282 54.3105 8.01343 54.6499 8.01343 55.0688Z",
  fill: "black"
})), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5728 56.9096V56.9626H18.3815V56.1539H18.3284C18.3284 56.5728 17.989 56.9096 17.5728 56.9096Z",
  fill: "black"
})), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9529 56.9616H18.3013V55.2116C18.3013 54.7137 18.705 54.3101 19.2029 54.3101H20.9529V56.9616Z",
  fill: "black"
})), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5251 54.3105H20.8735V56.962H23.5251V54.3105Z",
  fill: "black"
})), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4458 56.9617V54.3101H25.1958C25.6937 54.3101 26.0973 54.7138 26.0973 55.2117V56.9617H23.4458Z",
  fill: "black"
})), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
  d: "M31.1621 56.9617V55.2117C31.1621 54.7138 31.5657 54.3101 32.0636 54.3101H32.9121C33.41 54.3101 33.8136 54.7138 33.8136 55.2117V56.9617H31.1621Z",
  fill: "black"
})), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
  d: "M62.0254 55.0688V56.2063C62.0254 56.6253 62.3648 56.962 62.7837 56.962H63.9212C64.3428 56.962 64.6796 56.6226 64.6796 56.2037V55.0688C64.6769 54.6472 64.3375 54.3105 63.9186 54.3105H62.7837C62.3648 54.3105 62.0254 54.6499 62.0254 55.0688Z",
  fill: "black"
})), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
  d: "M69.8207 54.3107H67.1692V56.9623H69.8207V54.3107Z",
  fill: "black"
})), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
  d: "M74.9639 56.9617H72.3123V55.2117C72.3123 54.7138 72.716 54.3101 73.2139 54.3101H74.9639V56.9617Z",
  fill: "black"
})), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
  d: "M77.5372 54.3105H74.8856V56.962H77.5372V54.3105Z",
  fill: "black"
})), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1094 54.3105H77.4579V56.962H80.1094V54.3105Z",
  fill: "black"
})), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
  d: "M80.0293 54.3107H82.6808V56.0607C82.6808 56.5586 82.2772 56.9623 81.7793 56.9623H80.0293V54.3107Z",
  fill: "black"
})), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2366 59.535H11.4866C10.9887 59.535 10.585 59.1314 10.585 58.6335V57.785C10.585 57.2871 10.9887 56.8835 11.4866 56.8835H13.2366V59.535Z",
  fill: "black"
})), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8097 56.8812H13.1582V59.5327H15.8097V56.8812Z",
  fill: "black"
})), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3801 56.8812H15.7285V59.5327H18.3801V56.8812Z",
  fill: "black"
})), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9535 56.8812H18.302V59.5327H20.9535V56.8812Z",
  fill: "black"
})), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5248 56.8812H20.8733V59.5327H23.5248V56.8812Z",
  fill: "black"
})), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0173 57.6395V58.777C26.0173 59.196 26.3567 59.5327 26.7757 59.5327H27.9132C28.3348 59.5327 28.6715 59.1933 28.6715 58.7744V57.6395C28.6689 57.2179 28.3295 56.8812 27.9105 56.8812H26.7757C26.3567 56.8812 26.0173 57.2206 26.0173 57.6395Z",
  fill: "black"
})), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
  d: "M33.813 56.8812V58.6312C33.813 59.1291 33.4094 59.5327 32.9115 59.5327H32.063C31.5651 59.5327 31.1614 59.1291 31.1614 58.6312V56.8812H33.813Z",
  fill: "black"
})), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
  d: "M44.1007 59.5341H42.3507C41.8528 59.5341 41.4492 59.1304 41.4492 58.6325V57.784C41.4492 57.2861 41.8528 56.8825 42.3507 56.8825H44.1007V59.5341Z",
  fill: "black"
})), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
  d: "M44.0222 59.535V56.8835H45.7722C46.2701 56.8835 46.6738 57.2871 46.6738 57.785V59.535H44.0222Z",
  fill: "black"
})), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
  d: "M48.4358 59.48V59.533H49.2445V58.7243H49.1915C49.1915 59.1432 48.8521 59.48 48.4358 59.48Z",
  fill: "black"
})), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
  d: "M51.818 59.5341H49.1665V57.784C49.1665 57.2861 49.5701 56.8825 50.068 56.8825H51.818V59.5341Z",
  fill: "black"
})), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
  d: "M54.3891 56.8812H51.7375V59.5327H54.3891V56.8812Z",
  fill: "black"
})), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
  d: "M54.3091 59.535V56.8835H56.0591C56.557 56.8835 56.9606 57.2871 56.9606 57.785V59.535H54.3091Z",
  fill: "black"
})), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
  d: "M63.8684 59.48V59.533H64.6771V58.7243H64.6241C64.6241 59.1432 64.2847 59.48 63.8684 59.48Z",
  fill: "black"
})), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
  d: "M67.2487 59.535H64.5971V57.785C64.5971 57.2871 65.0007 56.8835 65.4986 56.8835H67.2487V59.535Z",
  fill: "black"
})), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
  d: "M69.8207 56.8812H67.1692V59.5327H69.8207V56.8812Z",
  fill: "black"
})), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
  d: "M74.964 56.8812V58.6312C74.964 59.1291 74.5604 59.5327 74.0625 59.5327H73.214C72.7161 59.5327 72.3124 59.1291 72.3124 58.6312V56.8812H74.964Z",
  fill: "black"
})), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
  d: "M8.01318 60.213V61.3505C8.01318 61.7694 8.35258 62.1062 8.77152 62.1062H9.90903C10.3306 62.1062 10.6674 61.7668 10.6674 61.3479V60.213C10.6647 59.7914 10.3253 59.4547 9.90638 59.4547H8.77152C8.35258 59.4547 8.01318 59.794 8.01318 60.213Z",
  fill: "black"
})), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
  d: "M15.809 59.4547V62.1062H14.0589C13.561 62.1062 13.1574 61.7026 13.1574 61.2047V59.4547H15.809Z",
  fill: "black"
})), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3801 59.4547H15.7285V62.1062H18.3801V59.4547Z",
  fill: "black"
})), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9535 59.4547H18.302V62.1062H20.9535V59.4547Z",
  fill: "black"
})), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5248 59.4547H20.8733V62.1062H23.5248V59.4547Z",
  fill: "black"
})), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4458 62.1055V59.4539H25.1958C25.6937 59.4539 26.0973 59.8576 26.0973 60.3555V62.1055H23.4458Z",
  fill: "black"
})), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5886 62.1055V60.3555C28.5886 59.8576 28.9922 59.4539 29.4901 59.4539H30.3386C30.8365 59.4539 31.2402 59.8576 31.2402 60.3555V62.1055H28.5886Z",
  fill: "black"
})), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
  d: "M49.2446 62.1055H47.4946C46.9967 62.1055 46.5931 61.7018 46.5931 61.2039V60.3555C46.5931 59.8576 46.9967 59.4539 47.4946 59.4539H49.2446V62.1055Z",
  fill: "black"
})), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
  d: "M51.8166 59.4547H49.165V62.1062H51.8166V59.4547Z",
  fill: "black"
})), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
  d: "M51.7375 59.4547H54.3891V61.2047C54.3891 61.7026 53.9855 62.1062 53.4876 62.1062H51.7375V59.4547Z",
  fill: "black"
})), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
  d: "M59.5333 62.1055H57.7833C57.2854 62.1055 56.8818 61.7018 56.8818 61.2039V60.3555C56.8818 59.8576 57.2854 59.4539 57.7833 59.4539H59.5333V62.1055Z",
  fill: "black"
})), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1044 59.4547H59.4529V62.1062H62.1044V59.4547Z",
  fill: "black"
})), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
  d: "M64.6769 59.4547H62.0254V62.1062H64.6769V59.4547Z",
  fill: "black"
})), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
  d: "M67.2492 59.4547H64.5977V62.1062H67.2492V59.4547Z",
  fill: "black"
})), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
  d: "M69.8207 59.4547H67.1692V62.1062H69.8207V59.4547Z",
  fill: "black"
})), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
  d: "M69.7416 62.1055V59.4539H71.4916C71.9895 59.4539 72.3931 59.8576 72.3931 60.3555V62.1055H69.7416Z",
  fill: "black"
})), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
  d: "M77.458 62.1055V60.3555C77.458 59.8576 77.8616 59.4539 78.3595 59.4539H79.208C79.7059 59.4539 80.1095 59.8576 80.1095 60.3555V62.1055H77.458Z",
  fill: "black"
})), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2402 62.0261H28.5886V64.6776H31.2402V62.0261Z",
  fill: "black"
})), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3854 64.6769H34.6354C34.1375 64.6769 33.7338 64.2733 33.7338 63.7754V62.9269C33.7338 62.429 34.1375 62.0254 34.6354 62.0254H36.3854V64.6769Z",
  fill: "black"
})), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3049 64.6769V62.0253H38.0549C38.5528 62.0253 38.9565 62.429 38.9565 62.9269V64.6769H36.3049Z",
  fill: "black"
})), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
  d: "M41.449 62.7844V63.9219C41.449 64.3409 41.7884 64.6776 42.2073 64.6776H43.3448C43.7664 64.6776 44.1032 64.3382 44.1032 63.9193V62.7844C44.1005 62.3628 43.7611 62.0261 43.3422 62.0261H42.2073C41.7884 62.0261 41.449 62.3655 41.449 62.7844Z",
  fill: "black"
})), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
  d: "M51.818 62.0261V63.7761C51.818 64.274 51.4144 64.6776 50.9165 64.6776H50.068C49.5701 64.6776 49.1665 64.274 49.1665 63.7761V62.0261H51.818Z",
  fill: "black"
})), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1044 62.0261H59.4529V64.6776H62.1044V62.0261Z",
  fill: "black"
})), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
  d: "M72.3932 62.0261H69.7417V64.6776H72.3932V62.0261Z",
  fill: "black"
})), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1088 62.0261V64.6776H78.3587C77.8609 64.6776 77.4572 64.274 77.4572 63.7761V62.0261H80.1088Z",
  fill: "black"
})), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
  d: "M80.0293 64.6769V62.0253H81.7793C82.2772 62.0253 82.6808 62.429 82.6808 62.9269V64.6769H80.0293Z",
  fill: "black"
})), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2416 64.5984V67.25H29.4916C28.9937 67.25 28.59 66.8464 28.59 66.3485V64.5984H31.2416Z",
  fill: "black"
})), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
  d: "M31.1621 67.2504V64.5988H32.9121C33.41 64.5988 33.8136 65.0025 33.8136 65.5003V67.2504H31.1621Z",
  fill: "black"
})), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
  d: "M38.8773 65.3568V66.4943C38.8773 66.9132 39.2167 67.25 39.6357 67.25H40.7732C41.1948 67.25 41.5315 66.9106 41.5315 66.4916V65.3568C41.5289 64.9352 41.1895 64.5984 40.7705 64.5984H39.6357C39.2167 64.5984 38.8773 64.9378 38.8773 65.3568Z",
  fill: "black"
})), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
  d: "M51.7374 65.3568V66.4943C51.7374 66.9132 52.0768 67.25 52.4958 67.25H53.6333C54.0549 67.25 54.3916 66.9106 54.3916 66.4916V65.3568C54.389 64.9352 54.0496 64.5984 53.6306 64.5984H52.4958C52.0768 64.5984 51.7374 64.9378 51.7374 65.3568Z",
  fill: "black"
})), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
  d: "M59.5333 67.2504H57.7833C57.2854 67.2504 56.8818 66.8467 56.8818 66.3488V65.5003C56.8818 65.0025 57.2854 64.5988 57.7833 64.5988H59.5333V67.2504Z",
  fill: "black"
})), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1044 64.5984H59.4529V67.25H62.1044V64.5984Z",
  fill: "black"
})), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
  d: "M64.5977 65.3568V66.4943C64.5977 66.9132 64.9371 67.25 65.356 67.25H66.4935C66.9151 67.25 67.2518 66.9106 67.2518 66.4916V65.3568C67.2492 64.9352 66.9098 64.5984 66.4909 64.5984H65.356C64.9371 64.5984 64.5977 64.9378 64.5977 65.3568Z",
  fill: "black"
})), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
  d: "M72.3932 64.5984H69.7417V67.25H72.3932V64.5984Z",
  fill: "black"
})), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
  d: "M74.8856 65.3568V66.4943C74.8856 66.9132 75.225 67.25 75.644 67.25H76.7815C77.2031 67.25 77.5398 66.9106 77.5398 66.4916V65.3568C77.5372 64.9352 77.1978 64.5984 76.7788 64.5984H75.644C75.225 64.5984 74.8856 64.9378 74.8856 65.3568Z",
  fill: "black"
})), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
  d: "M82.6802 64.5984V66.3485C82.6802 66.8464 82.2765 67.25 81.7787 67.25H80.9302C80.4323 67.25 80.0286 66.8464 80.0286 66.3485V64.5984H82.6802Z",
  fill: "black"
})), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
  d: "M33.813 67.171V69.8225H32.063C31.5651 69.8225 31.1614 69.4189 31.1614 68.921V67.171H33.813Z",
  fill: "black"
})), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3854 67.1707H33.7339V69.8223H36.3854V67.1707Z",
  fill: "black"
})), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3049 69.8218V67.1702H38.0549C38.5528 67.1702 38.9565 67.5739 38.9565 68.0718V69.8218H36.3049Z",
  fill: "black"
})), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
  d: "M43.291 69.7688V69.8218H44.0997V69.0131H44.0467C44.0467 69.4321 43.7073 69.7688 43.291 69.7688Z",
  fill: "black"
})), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
  d: "M46.6731 69.8218H44.0216V68.0718C44.0216 67.5739 44.4252 67.1702 44.9231 67.1702H46.6731V69.8218Z",
  fill: "black"
})), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
  d: "M46.5928 69.8218V67.1702H48.3428C48.8407 67.1702 49.2443 67.5739 49.2443 68.0718V69.8218H46.5928Z",
  fill: "black"
})), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1044 67.171H59.4529V69.8225H62.1044V67.171Z",
  fill: "black"
})), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
  d: "M69.0114 69.7688V69.8218H69.8201V69.0131H69.767C69.767 69.4321 69.4276 69.7688 69.0114 69.7688Z",
  fill: "black"
})), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
  d: "M72.3932 67.171H69.7417V69.8225H72.3932V67.171Z",
  fill: "black"
})), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
  d: "M77.458 69.8218V68.0718C77.458 67.5739 77.8616 67.1702 78.3595 67.1702H79.208C79.7059 67.1702 80.1095 67.5739 80.1095 68.0718V69.8218H77.458Z",
  fill: "black"
})), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5886 70.4997V71.6372C28.5886 72.0562 28.928 72.3929 29.347 72.3929H30.4845C30.9061 72.3929 31.2428 72.0535 31.2428 71.6346V70.4997C31.2402 70.0781 30.9008 69.7414 30.4818 69.7414H29.347C28.928 69.7414 28.5886 70.0808 28.5886 70.4997Z",
  fill: "black"
})), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3852 69.7414H33.7336V72.3929H36.3852V69.7414Z",
  fill: "black"
})), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3049 69.7414H38.9565V71.4914C38.9565 71.9893 38.5528 72.3929 38.0549 72.3929H36.3049V69.7414Z",
  fill: "black"
})), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
  d: "M40.7206 72.3402V72.3933H41.5293V71.5845H41.4763C41.4763 72.0035 41.1369 72.3402 40.7206 72.3402Z",
  fill: "black"
})), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
  d: "M44.1007 72.3932H41.4492V70.6432C41.4492 70.1453 41.8528 69.7417 42.3507 69.7417H44.1007V72.3932Z",
  fill: "black"
})), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
  d: "M46.6738 69.7414H44.0222V72.3929H46.6738V69.7414Z",
  fill: "black"
})), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
  d: "M49.2443 69.7414H46.5928V72.3929H49.2443V69.7414Z",
  fill: "black"
})), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1044 69.7414H59.4529V72.3929H62.1044V69.7414Z",
  fill: "black"
})), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
  d: "M64.6769 69.7414H62.0254V72.3929H64.6769V69.7414Z",
  fill: "black"
})), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
  d: "M67.2492 69.7414H64.5977V72.3929H67.2492V69.7414Z",
  fill: "black"
})), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
  d: "M69.8207 69.7414H67.1692V72.3929H69.8207V69.7414Z",
  fill: "black"
})), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
  d: "M72.3932 69.7414H69.7417V72.3929H72.3932V69.7414Z",
  fill: "black"
})), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
  d: "M72.313 72.3942V69.7427H74.063C74.5609 69.7427 74.9645 70.1463 74.9645 70.6442V72.3942H72.313Z",
  fill: "black"
})), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1088 69.7414V71.4914C80.1088 71.9893 79.7051 72.3929 79.2072 72.3929H78.3587C77.8609 72.3929 77.4572 71.9893 77.4572 71.4914V69.7414H80.1088Z",
  fill: "black"
})), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3855 72.3148V74.0648C36.3855 74.5627 35.9819 74.9663 35.484 74.9663H34.6355C34.1376 74.9663 33.734 74.5627 33.734 74.0648V72.3148H36.3855Z",
  fill: "black"
})), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5283 74.9656H38.8768V73.2156C38.8768 72.7177 39.2804 72.3141 39.7783 72.3141H41.5283V74.9656Z",
  fill: "black"
})), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
  d: "M44.1005 72.3148H41.449V74.9663H44.1005V72.3148Z",
  fill: "black"
})), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
  d: "M46.6738 72.3148H44.0222V74.9663H46.6738V72.3148Z",
  fill: "black"
})), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
  d: "M46.5928 72.3148H49.2443V74.0648C49.2443 74.5627 48.8407 74.9663 48.3428 74.9663H46.5928V72.3148Z",
  fill: "black"
})), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
  d: "M51.7375 73.0731V74.2106C51.7375 74.6296 52.0769 74.9663 52.4959 74.9663H53.6334C54.055 74.9663 54.3917 74.6269 54.3917 74.208V73.0731C54.3891 72.6515 54.0497 72.3148 53.6307 72.3148H52.4959C52.0769 72.3148 51.7375 72.6542 51.7375 73.0731Z",
  fill: "black"
})), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1038 72.3148V74.9663H60.3537C59.8558 74.9663 59.4522 74.5627 59.4522 74.0648V72.3148H62.1038Z",
  fill: "black"
})), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
  d: "M62.0254 72.3148H64.6769V74.0648C64.6769 74.5627 64.2733 74.9663 63.7754 74.9663H62.0254V72.3148Z",
  fill: "black"
})), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
  d: "M72.3932 72.3148H69.7417V74.9663H72.3932V72.3148Z",
  fill: "black"
})), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
  d: "M74.8855 73.0731V74.2106C74.8855 74.6296 75.2249 74.9663 75.6438 74.9663H76.7813C77.2029 74.9663 77.5397 74.6269 77.5397 74.208V73.0731C77.537 72.6515 77.1976 72.3148 76.7787 72.3148H75.6438C75.2249 72.3148 74.8855 72.6542 74.8855 73.0731Z",
  fill: "black"
})), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2416 77.537H28.59V75.787C28.59 75.2891 28.9937 74.8855 29.4916 74.8855H31.2416V77.537Z",
  fill: "black"
})), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
  d: "M31.1621 77.537V74.8855H32.9121C33.41 74.8855 33.8136 75.2891 33.8136 75.787V77.537H31.1621Z",
  fill: "black"
})), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
  d: "M38.1482 77.4852V77.5383H38.9569V76.7296H38.9039C38.9039 77.1485 38.5645 77.4852 38.1482 77.4852Z",
  fill: "black"
})), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5289 74.8864H38.8773V77.538H41.5289V74.8864Z",
  fill: "black"
})), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
  d: "M44.1005 74.8862H41.449V77.5377H44.1005V74.8862Z",
  fill: "black"
})), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
  d: "M44.0222 74.8862H46.6738V76.6362C46.6738 77.1341 46.2701 77.5377 45.7722 77.5377H44.0222V74.8862Z",
  fill: "black"
})), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
  d: "M53.5808 77.4851V77.5382H54.3895V76.7294H54.3365C54.3365 77.1484 53.9971 77.4851 53.5808 77.4851Z",
  fill: "black"
})), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
  d: "M56.9608 77.5371H54.3093V75.7871C54.3093 75.2892 54.7129 74.8856 55.2108 74.8856H56.9608V77.5371Z",
  fill: "black"
})), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
  d: "M56.8813 77.537V74.8855H58.6314C59.1293 74.8855 59.5329 75.2891 59.5329 75.787V77.537H56.8813Z",
  fill: "black"
})), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
  d: "M69.8201 77.537H67.1685V75.787C67.1685 75.2891 67.5722 74.8855 68.0701 74.8855H69.8201V77.537Z",
  fill: "black"
})), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
  d: "M72.3932 74.8862H69.7417V77.5377H72.3932V74.8862Z",
  fill: "black"
})), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
  d: "M72.313 77.537V74.8855H74.063C74.5609 74.8855 74.9645 75.2891 74.9645 75.787V77.537H72.313Z",
  fill: "black"
})), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
  d: "M80.0293 75.6445V76.782C80.0293 77.201 80.3687 77.5377 80.7876 77.5377H81.9251C82.3467 77.5377 82.6835 77.1983 82.6835 76.7794V75.6445C82.6808 75.2229 82.3414 74.8862 81.9225 74.8862H80.7876C80.3687 74.8862 80.0293 75.2256 80.0293 75.6445Z",
  fill: "black"
})), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2416 77.4587V80.1102H29.4916C28.9937 80.1102 28.59 79.7066 28.59 79.2087V77.4587H31.2416Z",
  fill: "black"
})), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8136 77.4587H31.1621V80.1102H33.8136V77.4587Z",
  fill: "black"
})), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3854 77.4587H33.7339V80.1102H36.3854V77.4587Z",
  fill: "black"
})), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
  d: "M38.9565 77.4587H36.3049V80.1102H38.9565V77.4587Z",
  fill: "black"
})), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5289 77.4587H38.8773V80.1102H41.5289V77.4587Z",
  fill: "black"
})), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
  d: "M41.449 77.4587H44.1005V79.2087C44.1005 79.7066 43.6969 80.1102 43.199 80.1102H41.449V77.4587Z",
  fill: "black"
})), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
  d: "M46.5928 78.217V79.3545C46.5928 79.7735 46.9322 80.1102 47.3511 80.1102H48.4886C48.9102 80.1102 49.247 79.7708 49.247 79.3519V78.217C49.2443 77.7954 48.9049 77.4587 48.486 77.4587H47.3511C46.9322 77.4587 46.5928 77.7981 46.5928 78.217Z",
  fill: "black"
})), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
  d: "M51.0085 80.0565V80.1095H51.8173V79.3008H51.7642C51.7642 79.7197 51.4248 80.0565 51.0085 80.0565Z",
  fill: "black"
})), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
  d: "M54.3884 80.1105H51.7369V78.3605C51.7369 77.8626 52.1405 77.4589 52.6384 77.4589H54.3884V80.1105Z",
  fill: "black"
})), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
  d: "M56.9606 77.4587H54.3091V80.1102H56.9606V77.4587Z",
  fill: "black"
})), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
  d: "M59.5329 77.4587H56.8813V80.1102H59.5329V77.4587Z",
  fill: "black"
})), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
  d: "M59.4529 80.1105V77.459H61.2029C61.7008 77.459 62.1044 77.8626 62.1044 78.3605V80.1105H59.4529Z",
  fill: "black"
})), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
  d: "M69.8201 77.4587V79.2087C69.8201 79.7066 69.4164 80.1102 68.9185 80.1102H68.0701C67.5722 80.1102 67.1685 79.7066 67.1685 79.2087V77.4587H69.8201Z",
  fill: "black"
})), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
  d: "M77.458 80.1105V78.3605C77.458 77.8626 77.8616 77.459 78.3595 77.459H79.208C79.7059 77.459 80.1095 77.8626 80.1095 78.3605V80.1105H77.458Z",
  fill: "black"
})), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
  d: "M33.813 80.0301V81.7801C33.813 82.278 33.4094 82.6816 32.9115 82.6816H32.063C31.5651 82.6816 31.1614 82.278 31.1614 81.7801V80.0301H33.813Z",
  fill: "black"
})), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
  d: "M38.9559 80.0301V82.6816H37.2059C36.708 82.6816 36.3044 82.278 36.3044 81.7801V80.0301H38.9559Z",
  fill: "black"
})), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
  d: "M38.8773 80.0298H41.5289V81.7799C41.5289 82.2778 41.1252 82.6814 40.6273 82.6814H38.8773V80.0298Z",
  fill: "black"
})), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
  d: "M51.818 82.6809H50.068C49.5701 82.6809 49.1665 82.2773 49.1665 81.7794V80.9309C49.1665 80.433 49.5701 80.0294 50.068 80.0294H51.818V82.6809Z",
  fill: "black"
})), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
  d: "M51.7374 80.0298H54.389V81.7799C54.389 82.2778 53.9853 82.6814 53.4874 82.6814H51.7374V80.0298Z",
  fill: "black"
})), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
  d: "M59.5323 80.0301V82.6816H57.7823C57.2844 82.6816 56.8808 82.278 56.8808 81.7801V80.0301H59.5323Z",
  fill: "black"
})), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
  d: "M59.4529 80.0301H62.1044V81.7801C62.1044 82.278 61.7008 82.6816 61.2029 82.6816H59.4529V80.0301Z",
  fill: "black"
})), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
  d: "M64.5977 80.7882V81.9257C64.5977 82.3446 64.9371 82.6814 65.356 82.6814H66.4935C66.9151 82.6814 67.2518 82.342 67.2518 81.923V80.7882C67.2492 80.3666 66.9098 80.0298 66.4909 80.0298H65.356C64.9371 80.0298 64.5977 80.3692 64.5977 80.7882Z",
  fill: "black"
})), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
  d: "M69.7417 80.7884V81.9259C69.7417 82.3449 70.0811 82.6816 70.5 82.6816H71.6376C72.0591 82.6816 72.3959 82.3422 72.3959 81.9233V80.7884C72.3932 80.3668 72.0538 80.0301 71.6349 80.0301H70.5C70.0811 80.0301 69.7417 80.3695 69.7417 80.7884Z",
  fill: "black"
})), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1088 80.0301V82.6816H78.3587C77.8609 82.6816 77.4572 82.278 77.4572 81.7801V80.0301H80.1088Z",
  fill: "black"
})), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
  d: "M80.0293 82.6809V80.0294H81.7793C82.2772 80.0294 82.6808 80.433 82.6808 80.9309V82.6809H80.0293Z",
  fill: "black"
})), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.9223 20.1406V14.4485C23.9223 11.922 23.5786 11.3055 23.4308 11.1574C23.2827 11.0095 22.6662 10.6658 20.1393 10.6658H14.4476C11.9207 10.6658 11.3042 11.0095 11.1564 11.1574C11.0086 11.3055 10.6646 11.922 10.6646 14.4485V20.1406C10.6646 22.6675 11.0086 23.284 11.1564 23.4321C11.3042 23.5796 11.9207 23.9236 14.4476 23.9236H20.1393C22.6662 23.9236 23.2827 23.5796 23.4308 23.4321C23.5786 23.284 23.9223 22.6675 23.9223 20.1406ZM20.1393 8.01434C25.3366 8.01434 26.5738 9.2516 26.5738 14.4485C26.5738 19.6458 26.5738 14.9437 26.5738 20.1406C26.5738 25.3379 25.3366 26.5751 20.1393 26.5751C14.9424 26.5751 19.6445 26.5751 14.4476 26.5751C9.25031 26.5751 8.01306 25.3379 8.01306 20.1406C8.01306 14.9437 8.01306 17.3509 8.01306 14.4485C8.01306 9.2516 9.25031 8.01434 14.4476 8.01434C19.6445 8.01434 14.9424 8.01434 20.1393 8.01434ZM18.5131 13.3174C20.7406 13.3174 21.2708 13.848 21.2708 16.0748C21.2708 18.3023 21.2708 16.2872 21.2708 18.5144C21.2708 20.7415 20.7406 21.272 18.5131 21.272C16.2859 21.272 18.301 21.272 16.0738 21.272C13.8467 21.272 13.3161 20.7415 13.3161 18.5144C13.3161 16.2872 13.3161 17.3188 13.3161 16.0748C13.3161 13.848 13.8467 13.3174 16.0738 13.3174C18.301 13.3174 16.2859 13.3174 18.5131 13.3174Z",
  fill: "black"
})), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M79.9234 20.1406V14.4485C79.9234 11.922 79.5797 11.3055 79.4319 11.1574C79.2838 11.0095 78.6673 10.6658 76.1404 10.6658H70.4487C67.9218 10.6658 67.3053 11.0095 67.1575 11.1574C67.0097 11.3055 66.6657 11.922 66.6657 14.4485V20.1406C66.6657 22.6675 67.0097 23.284 67.1575 23.4321C67.3053 23.5796 67.9218 23.9236 70.4487 23.9236H76.1404C78.6673 23.9236 79.2838 23.5796 79.4319 23.4321C79.5797 23.284 79.9234 22.6675 79.9234 20.1406ZM76.1404 8.01434C81.3377 8.01434 82.5749 9.2516 82.5749 14.4485C82.5749 19.6458 82.5749 14.9437 82.5749 20.1406C82.5749 25.3379 81.3377 26.5751 76.1404 26.5751C70.9435 26.5751 75.6456 26.5751 70.4487 26.5751C65.2514 26.5751 64.0142 25.3379 64.0142 20.1406C64.0142 14.9437 64.0142 17.3509 64.0142 14.4485C64.0142 9.2516 65.2514 8.01434 70.4487 8.01434C75.6456 8.01434 70.9435 8.01434 76.1404 8.01434ZM74.5142 13.3174C76.7417 13.3174 77.2719 13.848 77.2719 16.0748C77.2719 18.3023 77.2719 16.2872 77.2719 18.5144C77.2719 20.7415 76.7417 21.272 74.5142 21.272C72.287 21.272 74.3021 21.272 72.0749 21.272C69.8478 21.272 69.3172 20.7415 69.3172 18.5144C69.3172 16.2872 69.3172 17.3188 69.3172 16.0748C69.3172 13.848 69.8478 13.3174 72.0749 13.3174C74.3021 13.3174 72.287 13.3174 74.5142 13.3174Z",
  fill: "black"
})), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.9223 76.1417V70.4496C23.9223 67.923 23.5786 67.3065 23.4308 67.1584C23.2827 67.0106 22.6662 66.6669 20.1393 66.6669H14.4476C11.9207 66.6669 11.3042 67.0106 11.1564 67.1584C11.0086 67.3065 10.6646 67.923 10.6646 70.4496V76.1417C10.6646 78.6685 11.0086 79.285 11.1564 79.4331C11.3042 79.5806 11.9207 79.9247 14.4476 79.9247H20.1393C22.6662 79.9247 23.2827 79.5806 23.4308 79.4331C23.5786 79.285 23.9223 78.6685 23.9223 76.1417ZM20.1393 64.0154C25.3366 64.0154 26.5738 65.2526 26.5738 70.4496C26.5738 75.6468 26.5738 70.9447 26.5738 76.1417C26.5738 81.3389 25.3366 82.5762 20.1393 82.5762C14.9424 82.5762 19.6445 82.5762 14.4476 82.5762C9.25031 82.5762 8.01306 81.3389 8.01306 76.1417C8.01306 70.9447 8.01306 73.3519 8.01306 70.4496C8.01306 65.2526 9.25031 64.0154 14.4476 64.0154C19.6445 64.0154 14.9424 64.0154 20.1393 64.0154ZM18.5131 69.3185C20.7406 69.3185 21.2708 69.849 21.2708 72.0758C21.2708 74.3033 21.2708 72.2882 21.2708 74.5154C21.2708 76.7426 20.7406 77.2731 18.5131 77.2731C16.2859 77.2731 18.301 77.2731 16.0738 77.2731C13.8467 77.2731 13.3161 76.7426 13.3161 74.5154C13.3161 72.2882 13.3161 73.3198 13.3161 72.0758C13.3161 69.849 13.8467 69.3185 16.0738 69.3185C18.301 69.3185 16.2859 69.3185 18.5131 69.3185Z",
  fill: "black"
})), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.9573 45.3844C37.9573 41.8846 37.9573 40.1347 39.0445 39.0474C40.1318 37.9601 41.8817 37.9601 45.3816 37.9601H46.0003C49.5001 37.9601 51.2501 37.9601 52.3373 39.0474C53.4246 40.1347 53.4246 41.8846 53.4246 45.3844V46.0032C53.4246 49.503 53.4246 51.2529 52.3373 52.3402C51.2501 53.4275 49.5001 53.4275 46.0003 53.4275H45.3816C41.8817 53.4275 40.1318 53.4275 39.0445 52.3402C37.9573 51.2529 37.9573 49.503 37.9573 46.0032V45.3844Z",
  fill: "black"
})), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.3202 42.7296C44.2339 42.7296 43.3534 43.6101 43.3534 44.6964C43.3534 44.7899 43.3598 44.8817 43.3723 44.9712L43.455 45.5639L42.8567 45.5765C42.1503 45.5913 41.5821 46.1687 41.5821 46.8788C41.5821 47.5982 42.1653 48.1814 42.8847 48.1814C44.5616 48.1814 46.3479 48.1815 48.1985 48.1815C49.1625 48.1815 49.9439 47.4 49.9439 46.4361C49.9439 45.4721 49.1625 44.6906 48.1985 44.6906C48.0854 44.6906 47.9753 44.7013 47.8691 44.7216L47.3522 44.8201L47.2481 44.3044C47.0666 43.4059 46.2718 42.7296 45.3202 42.7296ZM48.242 49.245V49.2453H42.8171V49.2443C41.5415 49.2085 40.5183 48.1631 40.5183 46.8788C40.5183 45.7767 41.2716 44.8507 42.2915 44.5874C42.3489 42.9641 43.6829 41.6658 45.3202 41.6658C46.6179 41.6658 47.7243 42.481 48.1567 43.6272C48.1706 43.6269 48.1845 43.6268 48.1985 43.6268C49.75 43.6268 51.0077 44.8846 51.0077 46.4361C51.0077 47.973 49.7734 49.2217 48.242 49.245Z",
  fill: "white"
})));
export { SvgQr as ReactComponent };